import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
import TooltipInfoIcon from '../../TooltipInfoIcon';
import styles from './style.m.less';

interface Props {
    className?: string;
    children: React.ReactNode;
    subLabel?: React.ReactNode;
    htmlFor?: string;
    info?: string;
}

export const FormLabel = ({ className, children, subLabel, htmlFor, info }: Props) => (
    <label htmlFor={htmlFor} className={classNames(styles.label, className)}>
        {children} {subLabel && <span className={styles.subLabel}>{subLabel}</span>}
        {info && <TooltipInfoIcon tooltip={info} />}
    </label>
);

FormLabel.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    subLabel: PropTypes.node,
    htmlFor: PropTypes.string,
    info: PropTypes.string,
};
